// extracted by mini-css-extract-plugin
module.exports = {"screen":"Sessions_screen__2ZhGy"};